import "../styles/globals.css";
import type { AppProps } from "next/app";
import { trpc } from "../utils/trpc";

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <div className="">
        <Component {...pageProps} />
    </div>
  );
}

export default trpc.withTRPC(MyApp);
